import { useScheduleAvailabilityEditingEnabled } from '@/hooks/useScheduleAvailabilityEditingEnabled';
import { ScheduleAvailability } from '@/pages/ScheduleAvailability/ScheduleAvailability';
import { Spinner } from '@liza/ui/components/ui/spinner';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

// Defense in depth: the nav item is hidden when `scheduleAvailabilityEditingEnabled` is off, but a direct
// navigation to /schedule-availability must also be blocked. Wait for LaunchDarkly to finish loading
// before redirecting so a clinician with the flag on isn't bounced during the initial flag load — same
// pattern as the /appointments route guard.
const ScheduleAvailabilityRoute = (): React.ReactNode => {
  const { enabled, isReady } = useScheduleAvailabilityEditingEnabled();
  const navigate = useNavigate();

  useEffect(() => {
    if (isReady && !enabled) {
      void navigate({ to: '/patients', replace: true });
    }
  }, [isReady, enabled, navigate]);

  if (!isReady || !enabled) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner className="size-6" />
      </div>
    );
  }

  return <ScheduleAvailability />;
};

export const Route = createFileRoute('/_auth/schedule-availability/')({
  component: ScheduleAvailabilityRoute,
  loader: () => ({ crumb: 'Schedule availability' }),
});
